import { useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { OwnerDetailsResponseDto } from '@/features/owners/types/owners-dto';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {} & ApiHookProps;

export const useOwnerDetailsApi = ({id}: Props = {}) => {  
    const axiosInstance = useAxiosAuth();

    const {
        data: ownerDetailsData, 
        isLoading: isLoadingOwnerDetailsData, 
        isError: isErrorOwnerDetailsData
    } = useQuery({
        queryKey: [ApiConfig.queries.features.owners.queryKeys.details, id],
        queryFn: async (): Promise<OwnerDetailsResponseDto> => {
            const url = `${ApiConfig.queries.features.owners.endpoints.get}/${id}`;               
            const response = await axiosInstance.get<OwnerDetailsResponseDto>(url);
            return response.data;
        },
        enabled: !!id,
    });

    return { 
        ownerDetailsData,
        isLoadingOwnerDetailsData,
        isErrorOwnerDetailsData
    }
}